/* ===========================================================
   GODIAG 版式 D「橙色仪表盘」（BX）· 交互层

   三件事：
     1. 入场动效（与 gx 同一套安全策略：隐藏态由 JS 自己开启）
     2. 首屏表盘 —— 指针跟随「当前选中的路径」
     3. 左下角旋钮控制台 —— 本次还原的重点

   旋钮的行为模型（参考 dieantwoord.com 的实体旋钮，但接上了真实用途）：
     · 静止时指针指向「你现在滚到的区块」——它是个档位指示器
     · 悬停下方任一链接，指针预览摆到那一格
     · 可以直接拖着旋钮转，松手吸附到最近的卡位并跳过去
     · 键盘左右方向键换档，回车前往
   任何一步失败都不会影响页面本身：控制台是渐进增强，
   没有 JS 时 section 直接不渲染它（见 liquid），不会留下死控件。
   =========================================================== */
(function () {
  'use strict';

  /* 【只准执行一遍】
     每个 bx section 都自带一份 <script src="godiag-bx.js">，这样单独放进
     主题编辑器里也能自己跑起来。但浏览器对同一个 src 是【下载一次、每个标签
     各执行一次】——首页有 8 个 bx section，这个文件就被跑了 8 遍，
     于是轨道挂了 8 个定时器（滑动速度直接变成设定值的 8 倍）、
     表盘挂了 8 份 pointermove、控制台挂了 8 份 scroll 监听。
     这是线上实测出来的，不是理论担心。 */
  if (window.__bxBooted) return;
  window.__bxBooted = true;

  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var ROOT = document.documentElement;

  /* 元素级兜底：主题编辑器改设置会触发 shopify:section:load 重新 boot，
     加上未来万一有别的路径重复调用，都不该把监听挂第二遍。 */
  function once(el, tag) {
    if (el.dataset['bxi' + tag]) return false;
    el.dataset['bxi' + tag] = '1';
    return true;
  }

  function clamp(v, lo, hi) { return v < lo ? lo : (v > hi ? hi : v); }

  /* =========================================================
     1. 入场动效
     ========================================================= */
  var REVEAL_GROUPS = [
    ['.bx-hero-content', '.bx-hero-main > *, .bx-route'],
    ['.bx-featured',     '.bx-section-head, .bx-product'],
    ['.bx-jobs',         '.bx-kicker, .bx-title, .bx-job'],
    ['.bx-shop',         '.bx-section-head, .bx-shop-card'],
    ['.bx-kits',         '.bx-section-head, .bx-kit'],
    ['.bx-brands',       '.bx-kicker, .bx-title, .bx-brand'],
    ['.bx-software',     '.bx-kicker, .bx-title, .bx-library, .bx-license'],
    ['.bx-stats',        '.bx-stat'],
    ['.bx-trust',        '.bx-kicker, .bx-title, .bx-trust-card'],
    ['.bx-social',       '.bx-kicker, .bx-title, .bx-social-row'],
    ['.bx-cta',          '.bx-cta-panel > *, .bx-footer']
  ];

  function initReveal() {
    var els = [];
    REVEAL_GROUPS.forEach(function (g) {
      Array.prototype.forEach.call(document.querySelectorAll(g[0]), function (root) {
        Array.prototype.forEach.call(root.querySelectorAll(g[1]), function (el, i) {
          if (el.hasAttribute('data-bx-reveal')) return;
          el.setAttribute('data-bx-reveal', '');
          // 错开上限 10 档：品牌墙有 24 个，不封顶最后一个要等 1.3 秒才出现
          el.style.setProperty('--bx-i', Math.min(i, 10));
          els.push(el);
        });
      });
    });
    /* 去掉嵌套：容器和它的子元素不能同时淡入，opacity 会【相乘】——
       两边各走到 0.5 时实际只有 0.25，那一段又暗又长，正是"字看不清"的来源。
       实测首屏的三张路径卡就套在一个同样在淡入的 <nav> 里。
       保子不保父：子元素粒度更细，错开效果也在子元素上。 */
    els = els.filter(function (el) {
      if (!el.querySelector('[data-bx-reveal]')) return true;
      el.removeAttribute('data-bx-reveal');
      el.style.removeProperty('--bx-i');
      return false;
    });

    if (!els.length) return;
    if (RM.matches || !('IntersectionObserver' in window)) return;

    ROOT.classList.add('bx-anim');

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.01 });

    els.forEach(function (el) { io.observe(el); });

    function rescue() {
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.height > 0 && r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-in');
      });
    }
    // 首屏兜底 + 最终兜底：宁可丢动效，也不能让内容留在不可见状态。
    // 两道都用定时器：rAF 在页面不出帧时不执行（后台标签页、离屏环境），
    // 而这两道的职责恰恰是「观察器没能生效时也要把内容放出来」——
    // 兜底本身再依赖一个可能不触发的回调就没有意义了。
    setTimeout(rescue, 80);
    setTimeout(rescue, 1200);

    /* ---- 看门狗 ----
       上面两道只保证「元素被标记为该显示了」，不保证它真的显示出来了：
       显现是靠 CSS 过渡完成的，而过渡同样需要出帧才推进。
       实测在不出帧的环境里，标记为 .is-in 的元素会停在 opacity 0 ——
       等于动效把正文藏死了，这是本文件最不能接受的失败模式。

       所以再加一道：给已标记的元素 2 秒，如果仍然是全透明，
       就判定这个环境不推进过渡，切到 .bx-noanim。

       注意不能只摘掉 .bx-anim —— 已经在跑的过渡不会因此取消，元素会冻在
       中途值上（实测摘掉之后首屏标题仍停在 opacity 0）。.bx-noanim 那条规则
       显式写了 transition:none 来取消过渡，再用 !important 把终值钉死。
       正常浏览器永远走不到这里。 */
    function watchdog() {
      var marked = document.querySelectorAll('[data-bx-reveal].is-in');
      var stuck = false;
      for (var i = 0; i < marked.length; i++) {
        if (parseFloat(getComputedStyle(marked[i]).opacity) < 0.05) { stuck = true; break; }
      }
      if (!stuck) return;

      ROOT.classList.remove('bx-anim');

      /* 逐条取消卡住的过渡，而不是用 .bx-noanim 一刀切。

         .bx-noanim 那条写的是 transition:none !important，作用域是
         [data-bx-reveal] —— 而产品卡、任务格、品牌格、信任卡、社媒行
         恰好既是 reveal 元素、又各自有 hover 过渡。一刀切会把它们的
         hover 过渡也永久关掉（实测五类元素 transitionProperty 全变成 none）。

         正常浏览器走不到这里，但有个真实场景会：在后台标签页打开页面 →
         没有帧 → 看门狗触发 → 用户切回来，内容是可见了，
         可整页的 hover 过渡都失灵了，且这一次加载内不会恢复。

         所以只取消 opacity / transform 这两条（reveal 自己用的），
         其余过渡原样留着。取消之后元素落到「指定值」，
         而 .bx-anim 已经摘掉，指定值就是完全可见。 */
      var handled = true;
      els.forEach(function (el) {
        if (!el.getAnimations) { handled = false; return; }
        el.getAnimations().forEach(function (a) {
          var p = a.transitionProperty;
          if (p === 'opacity' || p === 'transform') {
            try { a.cancel(); } catch (e) { handled = false; }
          }
        });
      });
      // 浏览器不支持 getAnimations 时，退回一刀切——保内容可见优先
      if (!handled) ROOT.classList.add('bx-noanim');
    }
    setTimeout(watchdog, 2000);
    setTimeout(watchdog, 5000);
  }

  /* =========================================================
     2. 首屏表盘
     ========================================================= */
  function initGauge(scope) {
    var slot = scope.querySelector('.bx-gauge-slot');
    var gauge = scope.querySelector('.bx-gauge');
    if (!slot || !gauge) return;

    /* 速度表扇区：从 8 点（-210°）顺时针经 12 点到 4 点（+30°），共 240°。
       和刻度的 -120°…+120°（12 点为 0）严格对应：指针角 = 刻度角 - 90。
       原来是 -142…+48，和刻度对不上，所以指针扫不满盘面。 */
    var needleMin = -210, needleMax = 30;
    var IDLE = -200;                       // 静止停在起点附近，像真表归零
    var ticks = gauge.querySelectorAll('.bx-tick');
    var readName = gauge.querySelector('[data-bx-readout-name]');
    var readValue = gauge.querySelector('[data-bx-readout-value]');
    var idleName = readName ? readName.textContent : '';
    var resetTimer;

    function paintTicks(angle) {
      // 刻度用「12 点为 0」的坐标系，指针用「3 点为 0」，差 90°
      var lit = angle + 90;
      var best = null, bestD = Infinity;
      Array.prototype.forEach.call(ticks, function (t) {
        var a = parseFloat(t.getAttribute('data-a')) || 0;
        if (a <= lit) t.setAttribute('data-lit', ''); else t.removeAttribute('data-lit');
        t.removeAttribute('data-now');
        var d = Math.abs(a - lit);
        if (d < bestD) { bestD = d; best = t; }
      });
      // 指针正下方那一格单独标出来，读数落点更明确
      if (best) best.setAttribute('data-now', '');
    }

    function point(angle, name, value) {
      var a = clamp(angle, needleMin, needleMax);
      gauge.style.setProperty('--bx-needle', a.toFixed(1) + 'deg');
      gauge.dataset.mode = 'active';
      paintTicks(a);
      if (readName && name != null) readName.textContent = name;
      if (readValue && value != null) readValue.textContent = value;
      clearTimeout(resetTimer);
      resetTimer = setTimeout(function () {
        gauge.dataset.mode = 'idle';
        /* 指针必须在这里显式归位。

           初版把归位交给了下面那个"静止漂移"的 setInterval，结果是：
           漂移被 prefers-reduced-motion 和 document.hidden 两个条件挡住时，
           指针会永远停在最后指过的档位，而读数窗已经切回 standby ——
           针指着 By vehicle、字写着 standby，自相矛盾。
           实测在后台标签页里就是这样（停在 -30° 不动，6 秒采样五次全一样）。

           归位是状态的一部分，不是装饰；漂移才是装饰。 */
        gauge.style.setProperty('--bx-needle', IDLE + 'deg');
        paintTicks(IDLE);
        if (readName) readName.textContent = idleName;
        if (readValue) readValue.textContent = 'standby';
      }, 1400);
    }

    Array.prototype.forEach.call(scope.querySelectorAll('.bx-route'), function (route) {
      var go = function () {
        point(parseFloat(route.getAttribute('data-bx-angle')) || 0,
              route.getAttribute('data-bx-label') || '',
              'selected');
      };
      route.addEventListener('mouseenter', go);
      route.addEventListener('focus', go);
    });

    // 在表盘区域内移动鼠标，指针跟着走——它是块可以拨弄的表，不是贴纸
    slot.addEventListener('pointermove', function (ev) {
      var b = gauge.getBoundingClientRect();
      var deg = Math.atan2(ev.clientY - (b.top + b.height / 2),
                           ev.clientX - (b.left + b.width / 2)) * 180 / Math.PI;
      /* atan2 的值域是 (-180,180]，而扇区是 -210…+30（跨过 ±180）。
         盘面缺口正对 6 点（+90°），就以它为界把下半区左侧折成负角，
         否则鼠标移到左下会被 clamp 到 +30（右下），指针方向完全相反。 */
      if (deg > 90) deg -= 360;
      point(deg, null, 'manual');
    });

    paintTicks(IDLE);

    /* ---- 触屏：把针接到滚动进度上 ----

       上面两条交互（悬停路径卡、在盘面上移动鼠标）都依赖 hover，
       触屏一条都不会发生 —— 针就只剩下漂移，等于一张会抖的贴纸。
       这也是它当初在手机上被整块 display:none 的原因。

       接到滚动进度之后它重新有了真信息：滚得越远针扫得越大。
       速度表的比喻在这里反而比桌面端更成立。
       读数窗顺便显示控制台当前所在的区块名——那个值 initConsole
       已经在维护，直接读它的 [data-current]，不重复算一遍。

       不走 point()：point() 带 1.4 秒后归位的定时器，那是给
       "碰一下就走"的悬停用的；滚动是持续状态，归位会把针拽回去。 */
    if (window.matchMedia('(hover: none)').matches) {
      var sTick = false;
      var scrollGauge = function () {
        sTick = false;
        var h = document.documentElement.scrollHeight - window.innerHeight;
        if (h <= 0) return;
        var pct = clamp(window.scrollY / h, 0, 1);
        var a = needleMin + (needleMax - needleMin) * pct;
        gauge.style.setProperty('--bx-needle', a.toFixed(1) + 'deg');
        gauge.dataset.mode = 'active';        // 同时让漂移让位
        paintTicks(a);
        var cur = document.querySelector('.bx-console-link[data-current]');
        if (readName) readName.textContent = cur ? cur.textContent.trim() : idleName;
        if (readValue) readValue.textContent = Math.round(pct * 100) + '%';
      };
      window.addEventListener('scroll', function () {
        if (sTick) return;
        sTick = true;
        requestAnimationFrame(scrollGauge);
      }, { passive: true });
      scrollGauge();
    }

    /* ---- 静止时的缓慢漂移 ----
       删掉扫描条之后，盘面在没人交互时就完全不动了，看起来像张贴纸。
       让唯一那根针在 ±7° 内极慢地游走：真表的指针本来就不会绝对静止，
       这点幅度读作"设备在线"，又不会被误当成在指某个具体档位。

       只在 idle 时跑；一旦有交互（point() 会把 mode 切成 active）就让位，
       交互结束 1.4 秒后 mode 回到 idle，漂移自然接管。
       prefers-reduced-motion 下完全不跑。 */
    if (!RM.matches) {
      var phase = 0;
      setInterval(function () {
        if (gauge.dataset.mode === 'active' || document.hidden) return;
        phase += 1;
        var a = IDLE + Math.sin(phase / 3.4) * 7;
        gauge.style.setProperty('--bx-needle', a.toFixed(1) + 'deg');
        paintTicks(a);
      }, 1100);
    }
  }

  /* =========================================================
     2b. 主推卡的多角度图
     渐进增强：没有 JS 时只显示第一张（其余 hidden），缩略图不激活，
     不会留下点不动的死控件。
     ========================================================= */
  function initShots(card) {
    var fig = card.querySelector('[data-bx-shots]');
    var thumbs = card.querySelector('[data-bx-thumbs]');
    if (!fig) return;
    var imgs = Array.prototype.slice.call(fig.querySelectorAll('img'));
    if (imgs.length < 2) return;

    var buttons = thumbs ? Array.prototype.slice.call(thumbs.querySelectorAll('button')) : [];
    var at = 0, cycle;

    function show(i) {
      at = (i + imgs.length) % imgs.length;
      imgs.forEach(function (im, n) {
        if (n === at) im.removeAttribute('hidden'); else im.setAttribute('hidden', '');
      });
      buttons.forEach(function (b, n) {
        if (n === at) b.setAttribute('data-on', ''); else b.removeAttribute('data-on');
      });
    }

    buttons.forEach(function (b, i) {
      b.addEventListener('click', function (ev) {
        // 缩略图在卡片里，卡片内的商品名是链接，别让点击顺带跳走
        ev.preventDefault(); ev.stopPropagation();
        clearInterval(cycle); show(i);
      });
      b.tabIndex = 0;
    });

    /* 悬停时慢速轮换角度。用定时器而不是 rAF：
       这里是「每 1.1 秒换一张」，不需要对齐帧，
       而 rAF 在不出帧的环境里根本不执行。 */
    card.addEventListener('mouseenter', function () {
      if (RM.matches) return;
      // 2-8：只有真能悬停的设备才自动轮换角度。iOS 点/按会合成 mouseenter，触屏一按就轮播、
      // 换到还没加载的图就空白 1 秒。触屏想看别的角度点缩略图（下面 click 仍在）。
      if (!window.matchMedia || !window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;
      clearInterval(cycle);
      cycle = setInterval(function () { show(at + 1); }, 1100);
    });
    card.addEventListener('mouseleave', function () { clearInterval(cycle); show(0); });

    show(0);
    if (thumbs) thumbs.removeAttribute('aria-hidden');
  }

  /* =========================================================
     2c. 热销栅格的左右按钮
     轨道本身是原生横向滚动（触屏、滚轮、Tab 都能推），按钮只是辅助。
     ========================================================= */
  function initRail(section) {
    var rail = section.querySelector('[data-bx-rail]');
    var nav = section.querySelector('[data-bx-rail-nav]');
    if (!rail || !nav) return;
    var prev = nav.querySelector('[data-bx-prev]');
    var next = nav.querySelector('[data-bx-next]');

    function step() {
      /* 量第一张【可见】的卡。品牌 tab 模式下前面的卡可能是 hidden（display:none），
         量出来宽 0，一次只挪一个 gap 那么点，看起来像箭头坏了。 */
      var card = rail.querySelector(':scope > :not([hidden])') || rail.firstElementChild;
      if (!card) return rail.clientWidth * 0.8;
      // 大屏整页放大时矩形是放大后的像素、滚动量是放大前的——除回去，不然一次跳过好几张（9/30 晚）
      var w = card.getBoundingClientRect().width / (parseFloat(document.documentElement.style.zoom) || 1);
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 10;
      // 一次推两张，留半张在视野里，不至于失去位置感
      return (w + gap) * 2;
    }
    function sync() {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max;
      /* 没有可翻的内容就不出箭头（比如主推只有 3 款、或某个品牌 tab 只有两三件）。
         两个都置灰的箭头摆在那里，比没有箭头更像坏了。
         用行内 style 而不是 hidden：.bx-shop-nav 有 display:flex，会压过 [hidden]。 */
      nav.style.display = max > 0 ? '' : 'none';
    }
    /* 切品牌 tab 时由 initTabs 发这个事件：轨道回到最左，漂移的累加器也清零——
       不清的话下一帧漂移会把轨道写回切换前的位置。 */
    rail.addEventListener('bx:reset', function () {
      acc = 0; dir = 1; rail.scrollLeft = 0; sync();
    });
    function go(dir) {
      rail.scrollBy({ left: dir * step(), behavior: RM.matches ? 'auto' : 'smooth' });
      // 平滑滚动要等走完才知道到没到头；用定时器而不是 scrollend，
      // 后者支持面还不够宽
      setTimeout(sync, 420);
    }
    // 点箭头 = 用户接管，永久停（section schema 里也是这么写的）。
    // 原来这里只是 stopAuto，鼠标一移开又自己动起来，和说明不符。
    if (prev) prev.addEventListener('click', function () { killAuto(); go(-1); });
    if (next) next.addEventListener('click', function () { killAuto(); go(1); });
    rail.addEventListener('scroll', function () { sync(); }, { passive: true });
    window.addEventListener('resize', sync, { passive: true });

    /* ---- 自动滑动 ----

       做成【匀速缓慢漂移 + 一碰就停】，而不是每隔几秒硬切一张：
       这一段是两三千美元的决策型商品，定时硬切会在人读到一半时
       把卡片抽走，既读不完也点不准。匀速漂移不抢读者的位置感，
       想细看时鼠标一放就停住。

       到头不跳回开头，改成折返（ping-pong）——跳回去那一下
       比什么都更像"页面出故障了"。

       停的条件写全：悬停、键盘聚焦、手指按下、页面切到后台、
       区块滚出视口、以及用户一旦自己操作过（点箭头或拖动）就永久停，
       不再和用户抢方向盘。 */
    /* 速度按【每秒多少像素】写，不按"每次挪几 px"——后者一改节拍就得重算，
       而且看不出到底多快。默认 14px/s：一张 268px 的卡走完约 19 秒，
       是"你没盯着它也不会觉得它在动"的那种慢。可在主题设置里调。

       用小步长 + 高频率（约 60Hz）而不是 1px/38ms：后者每秒只跳 26 下，
       在 60Hz 屏上是肉眼可见的一格一格。scrollLeft 支持小数，
       所以自己攒一个浮点累加器，每帧写进去就是平滑的。 */
    var auto = null, dir = 1, userTook = false, acc = 0;
    var PPS = parseFloat(section.dataset.bxSpeed) || 14;   // px/秒
    var TICK = 16;                                          // ms，约 60Hz

    /* 暂停时【不】还回吸附。
       吸附是 x mandatory，一开回来浏览器会立刻把轨道吸到最近的卡片边界——
       而暂停最常见的触发就是鼠标移进来想细看，那一下会当着人的面跳一格，
       比不吸附难看得多。所以只在用户真正接管（点箭头/拖轨道）时才还回去，
       那时候本来就要对齐卡片。 */
    function stopAuto() {
      if (auto) { clearInterval(auto); auto = null; }
    }
    function killAuto() {
      userTook = true;
      stopAuto();
      delete rail.dataset.bxDrift;      // 还回吸附，之后手动滑动对齐卡片
    }

    function canRun() {
      if (userTook || RM.matches || document.hidden) return false;
      var r = section.getBoundingClientRect();
      // 区块不在视口里就不动，省电也避免"回来发现位置变了"
      return r.top < window.innerHeight && r.bottom > 0;
    }

    function startAuto() {
      if (auto || !canRun()) return;
      /* 漂移期间必须关掉吸附。
         轨道平时是 scroll-snap-type:x mandatory（手动滑动时对齐卡片边界很舒服），
         但强制吸附会把每次 1px 的位移直接吸回最近的卡片边界——实测写 scrollLeft=50
         读回来是 0，漂移永远动不了。proximity 同样不行，只有 none 可以（三种都实测过）。
         所以：自动漂移时关吸附，用户接管后立刻还回去。 */
      rail.dataset.bxDrift = 'on';
      acc = rail.scrollLeft;            // 从当前位置接着走，不跳
      var last = Date.now();
      auto = setInterval(function () {
        if (!canRun()) { stopAuto(); return; }
        var now = Date.now();
        // 按真实经过的时间推进：标签页被降频、机器卡了一下，速度也不会跟着变
        var dt = Math.min(now - last, 100) / 1000;
        last = now;
        var max = rail.scrollWidth - rail.clientWidth;
        if (max <= 0) return;
        if (acc >= max) { acc = max; dir = -1; }
        else if (acc <= 0) { acc = 0; dir = 1; }
        acc += PPS * dt * dir;
        rail.scrollLeft = acc;
      }, TICK);
    }

    if (section.dataset.bxAutoplay === 'true') {
      // 9/30 深夜用户：「这个只能自动播放不能手动滑动诶」——原来只有「按下」算接管：
      // 触控板左右滑不产生 pointerdown，漂移一直跟手抢位置；而且页面一滚动就重新开漂，哪怕鼠标还停在这排上。
      var hovering = false;
      ['mouseenter', 'focusin', 'pointerdown'].forEach(function (ev) {
        section.addEventListener(ev, stopAuto);
      });
      section.addEventListener('mouseenter', function () { hovering = true; });
      section.addEventListener('mouseleave', function () { hovering = false; startAuto(); });
      // 拖动轨道 / 触控板横滑 / 手指滑，都视为用户接管
      rail.addEventListener('pointerdown', killAuto);
      rail.addEventListener('touchstart', killAuto, { passive: true });
      rail.addEventListener('wheel', function (e) { if (Math.abs(e.deltaX) > Math.abs(e.deltaY) || e.shiftKey) killAuto(); }, { passive: true });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stopAuto(); else if (!hovering) startAuto();
      });
      window.addEventListener('scroll', function () {
        if (canRun() && !hovering) startAuto(); else stopAuto();
      }, { passive: true });
      startAuto();
    }

    sync();
  }

  /* =========================================================
     2d. 热销区的品牌 tab（2026-09-28 第二轮）
     所有 tab 的卡都已在同一条轨道里，这里只切 hidden，不请求、不跳页。
     键盘：左右键在 tab 间移动，Home / End 到头尾（WAI-ARIA tabs 的约定）。
     ========================================================= */
  function initTabs(section) {
    var bar = section.querySelector('[data-bx-tabs]');
    var rail = section.querySelector('[data-bx-rail]');
    if (!bar || !rail) return;
    var tabs = Array.prototype.slice.call(bar.querySelectorAll('[data-bx-tab]'));
    if (!tabs.length) return;

    function pick(id, focus) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-bx-tab') === id;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      Array.prototype.forEach.call(section.querySelectorAll('[data-bx-tab-panel]'), function (el) {
        el.hidden = el.getAttribute('data-bx-tab-panel') !== id;
      });
      rail.dispatchEvent(new CustomEvent('bx:reset'));
    }

    tabs.forEach(function (t, i) {
      t.tabIndex = t.getAttribute('aria-selected') === 'true' ? 0 : -1;
      t.addEventListener('click', function () { pick(t.getAttribute('data-bx-tab')); });
      t.addEventListener('keydown', function (e) {
        var j = -1;
        if (e.key === 'ArrowRight') j = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') j = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') j = 0;
        else if (e.key === 'End') j = tabs.length - 1;
        if (j < 0) return;
        e.preventDefault();
        pick(tabs[j].getAttribute('data-bx-tab'), true);
      });
    });
  }

  /* =========================================================
     3. 左下角旋钮控制台
     ========================================================= */
  function initConsole(node) {
    if (node.dataset.bxReady === '1') return;
    node.dataset.bxReady = '1';

    var dial = node.querySelector('.bx-dial');
    var label = node.querySelector('.bx-dial-label');
    var links = Array.prototype.slice.call(node.querySelectorAll('.bx-console-link'));
    var toggle = node.querySelector('.bx-console-toggle');
    if (!dial || !links.length) return;

    var SPAN = 108;                       // 卡位分布的半角
    var mobile = window.matchMedia('(max-width: 760px)');
    var count = links.length;
    var step = count > 1 ? (SPAN * 2) / (count - 1) : 0;
    var angles = links.map(function (_, i) { return count > 1 ? -SPAN + step * i : 0; });

    var index = 0;          // 当前档位
    var previewing = false; // 悬停预览中
    var dragging = false;

    // 卡位点
    var detentWrap = node.querySelector('.bx-dial-detents');
    if (detentWrap) {
      detentWrap.innerHTML = '';
      angles.forEach(function (a) {
        var d = document.createElement('span');
        d.className = 'bx-dial-detent';
        d.style.setProperty('--bx-detent', a.toFixed(2) + 'deg');
        detentWrap.appendChild(d);
      });
    }
    var detents = Array.prototype.slice.call(node.querySelectorAll('.bx-dial-detent'));

    function setAngle(a) { dial.style.setProperty('--bx-dial-a', a.toFixed(2) + 'deg'); }

    function paint(i, armed) {
      index = clamp(i, 0, count - 1);
      setAngle(angles[index]);
      detents.forEach(function (d, n) {
        if (n === index) d.setAttribute('data-on', ''); else d.removeAttribute('data-on');
      });
      links.forEach(function (l, n) {
        if (n === index) l.setAttribute('data-current', ''); else l.removeAttribute('data-current');
      });
      if (label) label.textContent = links[index].textContent.trim();
      dial.setAttribute('aria-valuenow', String(index + 1));
      dial.setAttribute('aria-valuetext', links[index].textContent.trim());
      node.dataset.armed = armed ? 'true' : 'false';
    }

    function nearest(a) {
      var best = 0, bestD = Infinity;
      angles.forEach(function (t, i) {
        var d = Math.abs(t - a);
        if (d < bestD) { bestD = d; best = i; }
      });
      return best;
    }

    function follow(href) {
      if (!href) return;
      var target = href.charAt(0) === '#' ? document.querySelector(href) : null;
      if (target) {
        target.scrollIntoView({ behavior: RM.matches ? 'auto' : 'smooth', block: 'start' });
      } else {
        window.location.href = href;
      }
    }

    /* ---- 悬停预览 ---- */
    links.forEach(function (link, i) {
      var enter = function () { previewing = true; paint(i, true); };
      var leave = function () { previewing = false; syncToScroll(true); };
      link.addEventListener('mouseenter', enter);
      link.addEventListener('focus', enter);
      link.addEventListener('mouseleave', leave);
      link.addEventListener('blur', leave);
      // 手机上点完链接把托盘收回去
      link.addEventListener('click', function () {
        if (mobile.matches) node.dataset.open = 'false';
      });
    });

    /* ---- 拖动旋钮 ---- */
    var dragMoved = 0, startX = 0, startY = 0;

    function angleFromEvent(ev) {
      var b = dial.getBoundingClientRect();
      // atan2 以 3 点为 0；指针以 12 点为 0，所以 +90
      var deg = Math.atan2(ev.clientY - (b.top + b.height / 2),
                           ev.clientX - (b.left + b.width / 2)) * 180 / Math.PI + 90;
      if (deg > 180) deg -= 360;
      return clamp(deg, -SPAN, SPAN);
    }

    dial.addEventListener('pointerdown', function (ev) {
      dragging = true; dragMoved = 0;
      startX = ev.clientX; startY = ev.clientY;
      dial.dataset.dragging = 'true';
      node.dataset.armed = 'true';
      if (dial.setPointerCapture) { try { dial.setPointerCapture(ev.pointerId); } catch (e) {} }
    });

    dial.addEventListener('pointermove', function (ev) {
      if (!dragging) return;
      dragMoved = Math.max(dragMoved,
        Math.abs(ev.clientX - startX) + Math.abs(ev.clientY - startY));
      var a = angleFromEvent(ev);
      setAngle(a);
      var n = nearest(a);
      detents.forEach(function (d, i) {
        if (i === n) d.setAttribute('data-on', ''); else d.removeAttribute('data-on');
      });
      if (label) label.textContent = links[n].textContent.trim();
    });

    function endDrag(ev) {
      if (!dragging) return;
      dragging = false;
      dial.dataset.dragging = 'false';
      // 位移小于 6px 视为点击，不是拖动
      if (dragMoved < 6) {
        if (mobile.matches) {
          node.dataset.open = node.dataset.open === 'true' ? 'false' : 'true';
          node.dataset.armed = node.dataset.open === 'true' ? 'true' : 'false';
          return;
        }
        follow(links[index].getAttribute('href'));
        return;
      }
      var n = nearest(angleFromEvent(ev));
      paint(n, true);
      follow(links[n].getAttribute('href'));
    }
    dial.addEventListener('pointerup', endDrag);
    dial.addEventListener('pointercancel', function () {
      dragging = false; dial.dataset.dragging = 'false'; syncToScroll(true);
    });

    /* ---- 键盘 ---- */
    dial.addEventListener('keydown', function (ev) {
      var k = ev.key;
      if (k === 'ArrowRight' || k === 'ArrowUp') { paint(index + 1, true); ev.preventDefault(); }
      else if (k === 'ArrowLeft' || k === 'ArrowDown') { paint(index - 1, true); ev.preventDefault(); }
      else if (k === 'Home') { paint(0, true); ev.preventDefault(); }
      else if (k === 'End') { paint(count - 1, true); ev.preventDefault(); }
      else if (k === 'Enter' || k === ' ') { follow(links[index].getAttribute('href')); ev.preventDefault(); }
    });
    dial.addEventListener('blur', function () { if (!previewing) syncToScroll(true); });

    /* ---- 滚动联动：指针指向你现在所在的区块 ---- */
    var targets = links.map(function (l) {
      var h = l.getAttribute('href') || '';
      return h.charAt(0) === '#' ? document.querySelector(h) : null;
    });

    function syncToScroll(force) {
      if (dragging || (previewing && !force)) return;
      var line = window.innerHeight * 0.42;
      var found = -1;
      targets.forEach(function (t, i) {
        if (!t) return;
        var r = t.getBoundingClientRect();
        // 被隐藏（display:none / 空 section）的目标 rect 全是 0，
        // 不排掉的话它永远"在线上方"，指针会被钉在那一格
        if (r.height === 0 && r.top === 0) return;
        if (r.top <= line) found = i;
      });
      if (found < 0) found = 0;
      if (found !== index || force) paint(found, false);
    }

    /* ---- 收起 / 展开 ----
       只剩用户主动这一条路径了：自动收缩（滚过首屏收成台阶、
       快到底自动让开）都已按要求移除，控制台在桌面端常驻。 */
    function collapse(on) {
      node.dataset.collapsed = on ? 'true' : 'false';
      if (toggle) {
        toggle.setAttribute('aria-expanded', on ? 'false' : 'true');
        toggle.firstChild.nodeValue = on ? (toggle.dataset.showLabel || 'Nav') :
                                           (toggle.dataset.hideLabel || 'Hide');
      }
    }
    if (toggle) {
      toggle.addEventListener('click', function () {
        collapse(node.dataset.collapsed !== 'true');
      });
    }

    /* ---- 滚动循环 ----
       节流用时间戳而不是 requestAnimationFrame 的布尔闩。

       原因：rAF 的回调在页面不出帧时不会执行（后台标签页、bfcache 恢复后、
       以及某些无头/离屏环境）。而「先把 ticking 置 true、等 rAF 回调里再置回
       false」这种写法一旦那一帧永远不来，闩就永久卡住——指针不再跟随滚动、
       收缩态也不再切换，且不会自己恢复。

       这里要跑的活儿很轻（对 ≤8 个锚点各取一次 rect），不需要对齐帧。
       用时间戳节流 + 一个收尾定时器：既没有可卡死的状态，
       也保证滚动停下后最终位置一定被应用。 */
    var lastRun = 0, trailing = null;
    var MIN_GAP = 60;

    function applyScrollState() {
      lastRun = Date.now();
      syncToScroll(false);
      /* 这里原本还做两件事，按要求都去掉了：
           · 滚过 220px 就切收缩态
           · 快到底时自动收起，免得压住页脚
         现在控制台在整页范围内保持常驻，只有用户点「Hide」才收。
         指针的滚动联动（syncToScroll）不受影响，照常跟着区块走。 */
    }

    function onScroll() {
      var now = Date.now();
      if (now - lastRun >= MIN_GAP) {
        applyScrollState();
      } else if (!trailing) {
        // 收尾：滚动停在两次节流之间时，最后的位置也要落到位
        trailing = setTimeout(function () {
          trailing = null;
          applyScrollState();
        }, MIN_GAP - (now - lastRun));
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    /* ---- 静止时的轻微抖动 ----
       真表的指针不会绝对静止。±1.1° 的偶发抖动就够读出「它是活的」，
       再大就成了故障。减弱动效偏好下完全不跑。 */
    if (!RM.matches) {
      setInterval(function () {
        if (dragging || previewing || document.hidden) return;
        var base = angles[index];
        setAngle(base + (Math.random() * 2.2 - 1.1));
        setTimeout(function () { if (!dragging && !previewing) setAngle(angles[index]); }, 420);
      }, 2600);
    }

    paint(0, false);
    syncToScroll(true);
    onScroll();
  }

  /* =========================================================
     扳手光标：按下去"拧一下"

     位图光标没法用 CSS 动画，但可以连着换帧——换的是真·系统光标，
     跟手零延迟，比在页面上画一个假光标可靠得多。
     按下：-12° → -24° → -34°，每帧 34ms，一共约 0.1 秒，读起来就是"拧上去了"。
     松开：退回 -24° → -12° → 0°，稍慢一点，像扳手回弹。

     只做 class 的加减，角度和图都在 CSS 里；这段没跑起来也只是没有转动，
     光标本身照常。只在 <html> 上挂一次监听，不碰任何 section 的 DOM。
     ========================================================= */
  var WRENCH_FRAMES = ['bx-wrench-1', 'bx-wrench-2', 'bx-wrench-3'];

  function initWrench() {
    if (initWrench.done) return;
    initWrench.done = true;

    // 开关：把扳手扩到整页（页头/顶栏/页脚/Cookie 条），细则全在 CSS 里
    ROOT.classList.add('bx-wrench-page');

    var timers = [];
    function clearTimers() {
      timers.forEach(clearTimeout);
      timers = [];
    }
    function setFrame(n) {
      for (var i = 0; i < WRENCH_FRAMES.length; i++) {
        ROOT.classList.toggle(WRENCH_FRAMES[i], i < n);
      }
    }
    // 逐帧推进；to<from 是回退。减弱动效偏好下直接到位，不做中间帧
    function run(from, to) {
      clearTimers();
      if (RM.matches) { setFrame(to); return; }
      var dir = to > from ? 1 : -1;
      var gap = dir > 0 ? 34 : 46;   // 回弹稍慢，像卸力
      // 第一帧同步画，不进 setTimeout：点击往往紧接着导航，
      // 主线程一忙 0ms 的定时器就可能等不到执行，按下去会一点反馈都没有
      setFrame(from + dir);
      for (var n = from + dir * 2, k = 1; dir > 0 ? n <= to : n >= to; n += dir, k++) {
        timers.push(setTimeout(setFrame.bind(null, n), gap * k));
      }
    }

    ROOT.addEventListener('pointerdown', function (ev) {
      // 触屏没有光标；非主键（右键/中键）也不该有"拧"的语义
      if (ev.pointerType === 'touch' || ev.button !== 0) return;
      if (!ev.target.closest || !ev.target.closest('.bx-hero, .bx-main, .bx-cta, .bx-console')) return;
      run(0, WRENCH_FRAMES.length);
    }, { passive: true });

    // pointerup 可能落在别处（拖出去再松手），所以监听挂在 window 上；
    // 切走标签页/弹出对话框时 blur 兜底，避免光标卡在拧住的状态
    ['pointerup', 'pointercancel', 'blur'].forEach(function (t) {
      window.addEventListener(t, function () { run(WRENCH_FRAMES.length, 0); }, { passive: true });
    });
  }

  /* =========================================================
     滚动浮动（视差）

     目的：让上下滑不像翻 PDF。做法是让不同深度的东西按不同速率走——
     远景（分隔图）跟着滚动方向多走一点，显得远；
     近景（授权面板、大标题）反向走一点，显得近。

     【为什么用 translate 而不是 transform】
     transform 已经被入场动效和各种 hover 占着（.bx-license:hover 有
     translateY(-3px)、reveal 有 translateY(14px)）。translate 是独立属性，
     和 transform 各算各的、自动合成，不用抢也不会互相覆盖。

     系数是「元素中心偏离视口中心一个视口高度时移动多少 px」。
     正=顺着滚动方向（显远），负=逆着（显近）。 */
  var FLOAT_GROUPS = [
    // [选择器, 位移系数 px, 缩放幅度]
    // 缩放在元素经过视口中心时最大，是"靠近了一点"的感觉。
    // 幅度只给 1.5%——再大就会让人注意到图在变形，那就穿帮了。
    ['.bx-divider img',           30, 0.015],
    ['.bx-hero .bx-gauge-slot',   16, 0],
    ['.bx-kit-image img',         11, 0.015],
    ['.bx-license',               -8, 0],
    ['.bx-main .bx-title',        -5, 0]
  ];

  function initFloat() {
    if (initFloat.done) return;
    initFloat.done = true;
    if (RM.matches) return;                 // 减弱动效偏好下完全不启用

    var items = [];
    FLOAT_GROUPS.forEach(function (g) {
      Array.prototype.forEach.call(document.querySelectorAll(g[0]), function (el) {
        if (items.some(function (it) { return it.el === el; })) return;
        items.push({ el: el, k: g[1], s: g[2] || 0 });
      });
    });

    /* ---- 卡片的「升起」----
       入场的一次性淡入只负责"出现"，出现完就结束了。这里补的是【持续跟着
       滚动变化】的那一层：块从视口下方上来时一边上移一边从 0.945 长到 1，
       离开视口顶部时再缩到 0.975 并后退一点。前后两块于是读起来像
       分层的板子在叠，而不是一张平铺的长图。

       为什么挂在卡片而不是整个区块：装箱单那一段有 1283px 高，比视口还高，
       整块做缩放根本看不出变化，反而会在你读到一半时整体抖一下。

       用 scale/translate 这两个【独立属性】而不是 transform：
       transform 已经被入场动效和 hover 占着了，独立属性会自动复合，
       不用去抢那一条声明。

       跳过品牌墙（24 个小格，缩放读不出来还白算 24 次矩形）和首屏路径卡
       （在首屏之上，根本没有"滚进来"这个时刻）。 */
    /* 【共享边框的网格项必须整块动，不能逐格动】
       数据条和任务格是 4 列网格，靠每格的 border-right/bottom 拼出连续网格线。
       逐格缩放会让相邻两格的边线错开，中间露出缝——看起来就是坏的。
       所以这两处挂在【容器】上（.bx-stats / .bx-job-list），整片一起升起。
       信任卡和下载格没这个问题：它们已经被上面的玻璃材质改成 border:0
       的独立圆角卡了，本来就不共享边线。 */
    var RISE = '.bx-product, .bx-shop-card, .bx-kit, .bx-trust-card, ' +
               '.bx-download-type, .bx-license, .bx-job-list, .bx-stats, .bx-cta-panel';
    var risers = Array.prototype.slice.call(document.querySelectorAll(RISE));

    if (!items.length && !risers.length) return;

    // 分隔图是 height:100% 装在 overflow:hidden 里的，不给行程一动就露边。
    // 这个 class 由 JS 加：视差没启用时就不该白白放大图片。
    ROOT.classList.add('bx-float');

    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight;
      /* 视口高度拿不到就直接不算。
         原来写的是 `innerHeight || 1`，看着是个稳妥的兜底，其实是陷阱：
         真有环境会报 0（离屏渲染、后台标签的某些时刻——本项目就实测到过），
         那时除以 1 会把偏移放大成几千 px，元素直接飞出画面。
         算不了就什么都不做，保持上一次的值，比算错好。 */
      if (!vh || vh < 200) return;
      // 先全部读、再全部写：读写交替会逼浏览器每次重算布局
      var ps = items.map(function (it) {
        var r = it.el.getBoundingClientRect();
        if (r.bottom < -240 || r.top > vh + 240) return null;   // 视口外不算
        return ((r.top + r.height / 2) - vh / 2) / vh;
      });
      // 升起：同样先全部读完再写，避免读写交替反复触发重排
      var rs = risers.map(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -120 || r.top > vh + 120) return null;
        return r;
      });

      items.forEach(function (it, i) {
        var p = ps[i];
        if (p === null) return;
        it.el.style.translate = '0 ' + (p * it.k).toFixed(2) + 'px';
        if (it.s) {
          // |p| 越接近 0（越靠视口中心）放得越大
          var near = 1 - Math.min(Math.abs(p) * 2, 1);
          it.el.style.scale = (1 + it.s * near).toFixed(4);
        }
      });

      risers.forEach(function (el, i) {
        var r = rs[i];
        if (!r) return;
        // t1：顶边从视口底部升上来的进度  t2：底边还没滑出视口顶部的余量
        var t1 = clamp((vh - r.top) / (vh * 0.6), 0, 1);
        var t2 = clamp(r.bottom / (vh * 0.45), 0, 1);
        el.style.scale = ((0.945 + 0.055 * t1) * (0.975 + 0.025 * t2)).toFixed(4);
        el.style.translate = '0 ' + (26 * (1 - t1) - 10 * (1 - t2)).toFixed(2) + 'px';
      });
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  /* =========================================================
     搜索实时建议（Shopify predictive search）

     为什么值得做：项目诊断阶段确认的权重是「搜索 > 设备品牌 > 任务 > 车辆」，
     搜索排第一。而原来首屏那个框是个纯表单——敲完要回车跳一整页
     才知道有没有结果，中间没有任何反馈。技师按型号和料号搜
     （实测 SO537 → GT100 排第一），能边敲边看到命中，差别很大。

     不新建后端：直接打 Shopify 自带的 /search/suggest.json。
     端点从 liquid 的 routes.predictive_search_url 传进来，
     不写死路径——这个店有 11 个语种，写死在 /fr /de 前缀下会 404。

     渐进增强：脚本没跑、请求失败、返回为空，表单都照常能提交。
     建议层只做加法，不接管原有行为。
     ========================================================= */
  function initSuggest(form) {
    var url = form.getAttribute('data-bx-suggest');
    var input = form.querySelector('input[type="search"]');
    var box = form.querySelector('.bx-suggest');
    if (!url || !input || !box || !window.fetch) return;

    var timer = null, ctrl = null, items = [], active = -1, lastQ = '';

    function close() {
      box.hidden = true; box.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      items = []; active = -1;
      /* 必须把去重用的 lastQ 一并清掉。
         不清的话：用户按 Esc 关掉 → 再敲同一个词 → 被 `q === lastQ` 挡住
         → 那个词的建议再也调不出来。实测复现过。 */
      lastQ = '';
    }
    function mark(i) {
      if (!items.length) return;
      if (active > -1 && items[active]) items[active].setAttribute('aria-selected', 'false');
      active = i;
      if (active < 0) { input.removeAttribute('aria-activedescendant'); return; }
      var el = items[active];
      el.setAttribute('aria-selected', 'true');
      input.setAttribute('aria-activedescendant', el.id);
      if (el.scrollIntoView) el.scrollIntoView({ block: 'nearest' });
    }
    /* 把 text 里命中 q 的那一段留常规字重，其余加粗——和 Google 的补全一个读法：
       你敲的部分不强调，补出来的部分才是新信息。
       全程用 textContent 建节点，不拼 HTML：词条来自店铺搜索数据，不当模板串用。
       （Shopify 其实回了现成的 styled_text，里面带 <mark>，但那是一段 HTML 字符串，
        为了不引入"把接口返回的串塞进 innerHTML"这个习惯，这里自己画。） */
    function hilite(el, text, q) {
      var lo = text.toLowerCase(), i = lo.indexOf(q.toLowerCase());
      if (i < 0 || !q) { el.textContent = text; return; }
      function bold(t) { if (!t) return; var b = document.createElement('b'); b.textContent = t; el.appendChild(b); }
      bold(text.slice(0, i));
      el.appendChild(document.createTextNode(text.slice(i, i + q.length)));
      bold(text.slice(i + q.length));
    }

    /* 接口回的价格是「3088.00」这样的纯数字（当前币种）。用浏览器自带的 Intl 按当前币种排成「$3,088.00」，
       币种取 Shopify.currency.active；拿不到或格式化失败就原样显示，不瞎猜符号。 */
    function fmtMoney(v) {
      var n = parseFloat(String(v).replace(/[^0-9.]/g, ''));
      var cur = window.Shopify && Shopify.currency && Shopify.currency.active;
      if (!isFinite(n) || !cur) return String(v);
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(n);
      } catch (e) { return String(v); }
    }

    var MAG = '<svg class="bx-suggest-mag" viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
      '<circle cx="7" cy="7" r="4.6" fill="none" stroke="currentColor" stroke-width="1.6"/>' +
      '<path d="M10.5 10.5 14 14" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';

    /* d = { queries: [...], products: [...] }
       一个字母时只出词条——单字母的商品结果是噪音（实测敲 a 出的是 CGDI 奔驰钥匙），
       而词条是店铺自己的搜索数据，敲 a 出的是 autel / acdp / adapter，正是要的效果。 */
    function render(d, q) {
      var qrows = (d.queries || []).slice(0, q.length < 2 ? 8 : 4);
      var prods = d.products || [];
      if (!qrows.length && !prods.length) { close(); return; }
      var frag = document.createDocumentFragment();
      var n = 0;

      qrows.forEach(function (item) {
        var a = document.createElement('a');
        a.className = 'bx-suggest-q';
        a.id = box.id + '-o' + (n++);
        a.setAttribute('role', 'option');
        a.setAttribute('aria-selected', 'false');
        /* 用词条自带的 url：它带 _psq/_psid 这些埋点参数，
           后台「搜索分析」才认得出这一次点击来自补全建议 */
        a.href = item.url || (form.getAttribute('action') + '?q=' + encodeURIComponent(item.text));
        a.innerHTML = MAG + '<span class="bx-suggest-qt"></span>';
        hilite(a.querySelector('.bx-suggest-qt'), item.text || '', q);
        frag.appendChild(a);
      });

      if (qrows.length && prods.length) {
        var hr = document.createElement('span');
        hr.className = 'bx-suggest-sep';
        hr.setAttribute('aria-hidden', 'true');
        frag.appendChild(hr);
      }

      prods.forEach(function (p) {
        var a = document.createElement('a');
        a.className = 'bx-suggest-row';
        a.id = box.id + '-o' + (n++);
        a.setAttribute('role', 'option');
        a.setAttribute('aria-selected', 'false');
        a.href = p.url;
        var img = p.image ? '<span class="bx-suggest-thumb"><img src="' + p.image +
          '" alt="" width="88" height="88" loading="lazy" decoding="async"></span>' : '';
        // 商品标题来自店铺数据，用 textContent 写入，不拼进 HTML
        a.innerHTML = img + '<span class="bx-suggest-text"><b></b><i></i></span>';
        a.querySelector('b').textContent = p.title || '';
        // 价格原来直接拼接口给的数字（「AUTEL · 3088.00」），没有货币符号，和页面上其它价格对不上（9/30 体检）。
        // 按当前币种格式化，并包进 .money，货币切换插件能认出来一起换算。
        var meta = a.querySelector('i');
        meta.textContent = p.vendor || '';
        if (p.price) {
          if (p.vendor) meta.appendChild(document.createTextNode(' · '));
          var money = document.createElement('span');
          money.className = 'money';
          money.textContent = fmtMoney(p.price);
          meta.appendChild(money);
        }
        frag.appendChild(a);
      });

      var all = document.createElement('a');
      all.className = 'bx-suggest-all';
      all.href = form.getAttribute('action') + '?q=' + encodeURIComponent(q) + '&type=product';
      all.setAttribute('role', 'option');
      all.setAttribute('aria-selected', 'false');
      all.id = box.id + '-all';
      all.textContent = 'See all results for \u201c' + q + '\u201d';
      frag.appendChild(all);

      box.innerHTML = '';
      box.appendChild(frag);
      box.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      items = Array.prototype.slice.call(box.querySelectorAll('[role="option"]'));
      active = -1;
    }
    function ask(q) {
      if (ctrl) { try { ctrl.abort(); } catch (e) {} }
      ctrl = ('AbortController' in window) ? new AbortController() : null;
      /* routes.predictive_search_url 给的是 /search/suggest（不带 .json），
         那个地址返回的是 HTML 片段不是 JSON——直接打会在 r.json() 抛错。
         补 .json 而不是写死路径：多语种前缀（/fr/search/suggest）照样成立。 */
      var base = url.replace(/\/+$/, '');
      if (!/\.json$/.test(base)) base += '.json';
      /* type=query 是 Shopify 自带的【搜索词】建议，不是商品——敲 im 回 im608 / im508 /
         autel im608，敲 g 回 gt100 / godiag / gt115。这层就是"像 Google 那样"的那一半。
         limit_scope=each：不加的话 limit 是两类共享的，词条会把商品挤掉。
         一个字母时不要商品（噪音），只要词条。 */
      var wide = q.length >= 2;
      var qs = base + '?q=' + encodeURIComponent(q) +
        '&resources[type]=' + (wide ? 'product,query' : 'query') +
        '&resources[limit]=' + (wide ? 6 : 8) +
        '&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,tag,vendor,product_type,variants.sku,variants.barcode';
      fetch(qs, ctrl ? { signal: ctrl.signal } : undefined)
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d || input.value.trim() !== q) return;      // 已经敲了新的，丢弃这次
          var res = ((d.resources || {}).results || {});
          render({ queries: res.queries || [], products: res.products || [] }, q);
        })
        .catch(function () { /* 失败就当没有建议，表单照常可用 */ });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 1) { close(); lastQ = ''; return; }
      if (q === lastQ) return;
      lastQ = q;
      timer = setTimeout(function () { ask(q); }, 180);
    });

    input.addEventListener('keydown', function (ev) {
      if (box.hidden) return;
      if (ev.key === 'ArrowDown') { ev.preventDefault(); mark(active + 1 >= items.length ? 0 : active + 1); }
      else if (ev.key === 'ArrowUp') { ev.preventDefault(); mark(active - 1 < 0 ? items.length - 1 : active - 1); }
      else if (ev.key === 'Escape') { close(); }
      else if (ev.key === 'Enter' && active > -1) {
        // 只有【选中了某一条】才拦截回车；没选中就走正常提交
        ev.preventDefault();
        items[active].click();
      }
    });

    input.addEventListener('focus', function () {
      var q = input.value.trim();
      if (q.length < 1) return;
      // 已经有结果就直接展开；被关掉过（items 空了）就重新问一次，
      // 而不是让用户对着一个不响应的输入框发呆
      if (items.length) { box.hidden = false; input.setAttribute('aria-expanded', 'true'); }
      else { lastQ = q; ask(q); }
    });
    document.addEventListener('pointerdown', function (ev) {
      if (!form.contains(ev.target)) close();
    }, { passive: true });
    form.addEventListener('submit', close);
  }

  /* =========================================================
     去掉重复的样式表

     和上面的脚本重复是同一个来源：每个 bx section 各自 emit 一份
     <link href="godiag-bx.css">，8 个 section 就是 8 份【内容完全一样】的表。
     实测线上是 8 份 × 296 条 = 2368 条规则，每次样式重算都要全查一遍。
     （这是 Shopify 分区块引资源的固有代价，Dawn 也一样，不是本版引入的。）

     用 disabled 而不是 remove()：主题编辑器删掉某个 section 时，
     被留下的那个 <link> 可能正好跟着走。留在 DOM 里就随时能再启用回来。
     每次 section 增删后都重跑一遍，并且永远保证【至少有一份是启用的】。
     ========================================================= */
  function dedupeCss() {
    var links = document.querySelectorAll('link[href*="godiag-bx.css"]');
    var kept = false;
    Array.prototype.forEach.call(links, function (l) {
      if (!l.isConnected) return;
      if (!kept) { l.disabled = false; kept = true; }
      else { l.disabled = true; }
    });
  }

  /* =========================================================
     头部收藏计数

     问题：点了收藏，头部那颗心没有任何变化，看起来像没生效。
     实际 localStorage 存进去了，只是【计数看不见】——
     yonghui-header 把数字放在 .yh-tool__text 里（"Products (N) saved"），
     而 dark-skin 在 ≥750px 时把 .yh-tool__text 整个 display:none 了，
     只留图标。购物车有 ::after 角标兜底，收藏没有。

     这里补上：把数量写进 data-count，CSS 那边照购物车同一套画角标。
     不改 yonghui-wishlist 本身——那个文件 A 版也在用。

     为什么要监听 click 而不是直接改 wishlist 的 save()：
     同上，不碰共用文件。收藏按钮的 click 冒泡到 document 时
     localStorage 已经写完了，读一次就是新值。
     ========================================================= */
  function syncWishCount() {
    var n = 0;
    try { n = (JSON.parse(localStorage.getItem('yh_wishlist') || '[]') || []).length; }
    catch (e) { n = 0; }
    Array.prototype.forEach.call(
      document.querySelectorAll('.yh-tool--wishlist'),
      function (el) { el.setAttribute('data-count', String(n)); });
  }

  function initWishCount() {
    syncWishCount();
    /* 用捕获阶段之外的冒泡：等 wishlist 自己的 handler 先跑完再读 */
    document.addEventListener('click', function (ev) {
      if (ev.target && ev.target.closest && ev.target.closest('.yh-heart-btn')) {
        setTimeout(syncWishCount, 0);
      }
    });
    /* 另一个标签页里收藏了，这边也跟上 */
    window.addEventListener('storage', function (ev) {
      if (!ev.key || ev.key === 'yh_wishlist') syncWishCount();
    });
  }

  /* =========================================================
     启动
     ========================================================= */
  /* =========================================================
     N. 商品正文的结构还原

     甲方 2026-09-03：「宝贝详情页好丑」。查下来不是样式问题，是内容
     本身没有结构——店里大量商品的正文是这样写的：

       <p>Functions:</p>
       <p>1. Synchronous detection<br>2. Independent diagnosis<br>…</p>

     一个段落里塞 22 个 <br> 冒充编号列表。浏览器只能按散文排，
     于是十几条功能挤成一坨，扫不到重点。这是买家决定买不买的那块内容。

     为什么在 JS 里做而不是 Liquid：正文是甲方在后台富文本编辑器里敲的
     任意 HTML，Liquid 只能做字符串切分，切 <br> 会把 <p> 边界一起切碎。
     DOM 里做能保住每行自己的内联标签（链接、加粗都在）。

     渐进增强：转换失败或没有 JS 时，正文和原来一模一样，一个字不少。
     只在【至少 3 行带编号】时才动手，避免把正常换行的散文误判成列表。
     ========================================================= */
  var RTE_NUM = /^\s*(\d{1,2})\s*[.、)]\s+/;
  var RTE_BUL = /^\s*[•·▪\-–—*]\s+/;

  function rteLines(p) {
    /* 按 <br> 切成行，保留每行的内联 HTML */
    return p.innerHTML.split(/<br\s*\/?>/i).map(function (h) {
      var d = document.createElement('div');
      d.innerHTML = h;
      return { html: h, text: (d.textContent || '').replace(/ /g, ' ').trim() };
    });
  }

  function rteToList(p) {
    var lines = rteLines(p);
    var numbered = lines.filter(function (l) { return RTE_NUM.test(l.text); }).length;
    var bulleted = lines.filter(function (l) { return RTE_BUL.test(l.text); }).length;
    if (numbered < 3 && bulleted < 3) return false;

    var ordered = numbered >= bulleted;
    var re = ordered ? RTE_NUM : RTE_BUL;
    var frag = document.createDocumentFragment();
    var list = null, li = null, lead = null;

    lines.forEach(function (l) {
      if (!l.text) return;
      if (re.test(l.text)) {
        if (!list) {
          list = document.createElement(ordered ? 'ol' : 'ul');
          list.className = 'pdd__steps';
          frag.appendChild(list);
        }
        li = document.createElement('li');
        /* 只去掉行首的编号/项目符号，其余 HTML 原样保留 */
        li.innerHTML = l.html.replace(/^(\s|&nbsp;)*/, '').replace(ordered ? /^\s*\d{1,2}\s*[.、)]\s*/ : /^\s*[•·▪\-–—*]\s*/, '');
        list.appendChild(li);
      } else if (li) {
        /* 编号行的续行（比如括号里的补充说明），并进上一条 */
        li.insertAdjacentHTML('beforeend', ' ' + l.html);
      } else {
        /* 列表开始之前的引导句 */
        if (!lead) { lead = document.createElement('p'); frag.appendChild(lead); }
        else lead.insertAdjacentHTML('beforeend', '<br>');
        lead.insertAdjacentHTML('beforeend', l.html);
      }
    });

    if (!list) return false;
    p.parentNode.replaceChild(frag, p);
    return true;
  }

  /* 没有编号、但一段里塞了四行以上完整句子的「墙」。
     全店实测：380 个商品是编号列表（rteToList 处理），
     另有 864 个是这种——每个 <br> 后面都是一句独立的话（卖点、说明），
     但挤在一个段落里只靠行高分隔，扫不出有几条。
     只拆段落、不改行结构：浏览器本来就在这些位置换行，
     这一步只是把行距换成段距，一个字都不动。
     门槛定在【≥4 行且平均长度 ≥25 字】——短的两三行本来就是散文，拆了反而碎。 */
  function rteToParas(p) {
    var lines = rteLines(p).filter(function (l) { return l.text; });
    if (lines.length < 4) return false;
    var avg = lines.reduce(function (a, l) { return a + l.text.length; }, 0) / lines.length;
    if (avg < 25) return false;
    var frag = document.createDocumentFragment();
    lines.forEach(function (l) {
      var np = document.createElement('p');
      np.className = 'pdd__line';
      np.innerHTML = l.html;
      frag.appendChild(np);
    });
    p.parentNode.replaceChild(frag, p);
    return true;
  }

  function initRte(rte) {
    var ps = Array.prototype.slice.call(rte.querySelectorAll('p'));
    ps.forEach(function (p) {
      if (!/<br\s*\/?>/i.test(p.innerHTML)) return;
      try {
        if (!rteToList(p)) rteToParas(p);
      } catch (e) { /* 转换失败就保持原样，不影响阅读 */ }
    });

    /* 「Functions:」「Package includes:」这类独占一行的粗体短句本来就是小标题，
       但在后台被敲成了普通段落。提成 h3，锚点导航之外再多一层可扫的层级。 */
    Array.prototype.forEach.call(rte.querySelectorAll('p'), function (p) {
      var t = (p.textContent || '').trim();
      if (t.length > 48 || !/[:：]$/.test(t)) return;
      if (p.children.length !== 1) return;
      var only = p.children[0];
      if (!/^(STRONG|B)$/.test(only.tagName)) return;
      if ((only.textContent || '').trim() !== t) return;
      var h = document.createElement('h3');
      h.className = 'pdd__sub';
      h.textContent = t.replace(/[:：]$/, '');
      p.parentNode.replaceChild(h, p);
    });
  }

  /* =========================================================
     首屏活动图轮播（9/29）
     结构：横向 scroll-snap 轨道，一张一屏。手指滑、触控板横扫都是原生滚动，
     脚本只做三件事：圆点跟着当前张走、点圆点跳过去、自动往下一张走。
     自动切换在这些情况下停：鼠标悬停、键盘焦点在里面、页面在后台、系统要求减少动态效果。
     ========================================================= */
  function initBanner(node) {
    var track = node.querySelector('[data-bx-banner-track]');
    var dots = Array.prototype.slice.call(node.querySelectorAll('[data-bx-banner-dots] button'));
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    if (slides.length < 2) return;
    var cur = 0, timer = null, hold = false;
    // 10-21 自动播放开关、每张几秒改由编辑器设置（section 写在 data 属性上）；读不到就照旧：自动播、5.5 秒
    var auto = node.getAttribute('data-bx-autoplay') !== 'false';
    var gap = parseFloat(node.getAttribute('data-bx-interval'));
    var ms = gap > 0 ? gap * 1000 : 5500;

    function mark(i) {
      cur = i;
      dots.forEach(function (d, n) { if (n === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      slides.forEach(function (s, n) {
        if (n === i) { s.removeAttribute('aria-hidden'); s.removeAttribute('inert'); }
        else { s.setAttribute('aria-hidden', 'true'); s.setAttribute('inert', ''); }
      });
    }
    function go(i) {
      i = (i + slides.length) % slides.length;
      // 每张都是轨道的 100% 宽，第 i 张就在 i 个轨道宽的位置
      track.scrollTo({ left: i * track.clientWidth, behavior: RM.matches ? 'auto' : 'smooth' });
      mark(i);
    }
    // 圆点跟随：滚动停下来后按位置算当前张
    var st = null;
    track.addEventListener('scroll', function () {
      clearTimeout(st);
      st = setTimeout(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== cur) mark(Math.max(0, Math.min(slides.length - 1, i)));
      }, 90);
    }, { passive: true });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); restart(); }); });

    function tick() { if (!hold && !document.hidden) go(cur + 1); }
    function restart() {
      clearInterval(timer);
      if (auto && !RM.matches) timer = setInterval(tick, ms);
    }
    node.addEventListener('mouseenter', function () { hold = true; });
    node.addEventListener('mouseleave', function () { hold = false; });
    node.addEventListener('focusin', function () { hold = true; });
    node.addEventListener('focusout', function () { hold = false; });
    track.addEventListener('touchstart', function () { hold = true; }, { passive: true });
    track.addEventListener('touchend', function () { setTimeout(function () { hold = false; }, 4000); }, { passive: true });
    mark(0);
    restart();
  }

  function boot(scope) {
    var root = scope || document;
    initReveal();
    initWrench();
    initFloat();
    if (once(document.documentElement, 'wc')) initWishCount();
    function each(sel, tag, fn) {
      Array.prototype.forEach.call(root.querySelectorAll(sel), function (el) {
        if (once(el, tag)) fn(el);
      });
    }
    each('.bx-hero',    'g', initGauge);
    each('.bx-product', 's', initShots);
    each('.bx-shop',    'r', initRail);
    each('.bx-featured', 'r', initRail);        // 2026-09-28：主推也走同一套轨道
    each('.bx-shop--tabs', 't', initTabs);      // 必须在 initRail 之后：要用到它挂的 bx:reset
    each('.bx-console', 'c', initConsole);
    each('[data-bx-suggest]', 'q', initSuggest);
    each('.pdd__rte', 'x', initRte);
    each('[data-bx-banner]', 'b', initBanner);
    dedupeCss();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  // 主题编辑器里改设置会重渲染单个 section，重新挂一次
  document.addEventListener('shopify:section:load', function (ev) { boot(ev.target); });
  // 删掉某个 section 时，被留下的那份样式表可能正好跟着走；等 DOM 落定后重挑一份
  document.addEventListener('shopify:section:unload', function () { setTimeout(dedupeCss, 0); });
})();
